import React from "react";
import { MailCheck, Eye, UserMinus, TrendingUp } from "lucide-react";

export const digestRate = value => value == null ? "—" : `${value}%`;

export const PayDigestMetrics = ({ totals }) => {
    const metrics = [
        { id: "sent", label: "Emails accepted", value: totals.sent, note: "Accepted by email provider", icon: MailCheck, color: "text-emerald-600" },
        { id: "open-rate", label: "Unique open rate", value: digestRate(totals.open_rate), note: `${totals.opened} of ${totals.sent} emails`, icon: Eye, color: "text-sky-600" },
        { id: "opt-out-rate", label: "Opt-out rate", value: digestRate(totals.opt_out_rate), note: `${totals.opted_out} of ${totals.sent} emails`, icon: UserMinus, color: "text-amber-600" },
        { id: "conversion-rate", label: "DOE → range", value: digestRate(totals.conversion_rate), note: `${totals.converted_jobs} of ${totals.jobs_reminded} reminded postings · within 7 days`, icon: TrendingUp, color: "text-emerald-600" },
    ];
    return <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5 py-6 border-y border-border" data-testid="pay-digest-metrics">
        {metrics.map(({ id, label, value, note, icon: Icon, color }) => <div key={id} className="min-w-0">
            <div className="flex items-center gap-2 text-sm text-muted-foreground"><Icon size={16} className={color} />{label}</div>
            <div className="mt-3 font-heading text-3xl font-semibold tabular-nums" data-testid={`pay-digest-${id}`}>{value}</div>
            <p className="mt-1 text-xs text-muted-foreground" data-testid={`pay-digest-${id}-basis`}>{note}</p>
        </div>)}
    </div>;
};